export default __webpack_public_path__ + "static/media/seconf-left-img.87004db2.png";